var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnsKakaotalk = function SvgSnsKakaotalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.582 0 0 2.871 0 6.415c0 2.277 1.484 4.276 3.712 5.416l-.754 2.857a.239.239 0 0 0 .058.244c.043.044.1.068.163.068.048 0 .096-.02.14-.054l3.24-2.223c.471.069.951.107 1.44.107C12.419 12.83 16 9.96 16 6.416 16 2.871 12.418 0 8 0",
    fill: "current"
  })));
};
export default SvgSnsKakaotalk;